<template>
    <div class="learningpath-item-vertical">
        <router-link
            v-if="learningPath"
            class="learningpath-item-vertical__router-link"
            role="button"
            :to="getRouteToLearningPath(learningPath.slug, learningPath)"
        >
            <div class="learningpath-item-vertical__image-box">
                <img class="learningpath-item-vertical__image" :src="image" alt="" v-if="isImage">
                <img class="learningpath-item-vertical__image-center-logo" :src="learningpathThumbnailLogo" alt="">
                <ThumbnailInstructors :course="learningPath" />
            </div>
            <div class="learningpath-item-vertical__info-box">
                <span class="learningpath-item-vertical__title">{{ learningPath.title | truncate(140)}}</span>
                <ThumbnailInfoTable itemType="learningpath" :entity="learningPath" />
                <div class="learningpath-item-vertical__description">
                    <span class="-v-html" v-html="truncateDescription"></span>
                </div>
                <ThumbnailVerticalDetails itemType="learningpath" :course="learningPath" />
                <div class="learningpath-item-vertical__progress-bar">
                    <LearningPathProgressBar
                        :progress="learningPath.percentageCompleted"
                        :isSubscribed="isLearningPathSubscribed"
                        :isLearningPathProgress="true"
                        :isCourseListItem="true"
                        :isCompleted="isLearningPathCompleted"
                    />
                </div>
                <TotemLockIcon v-if="userHasNoAccess" isVertical />
            </div>
        </router-link>
        <TotemAddToWatchlistButton
            v-if="showAddToFavourite"
            type="learningPath"
            :elementId="learningPath.id"
        />
    </div>
</template>

<script>
    import LearningPathItemHelper from 'components/shared/global-courses-items/helper/learningpath-item-helper'
    import LearningPathProgressBar from 'components/learningpathpage/banner/LearningPathProgressBar'
    import convertMinutesToHours from 'components/shared/mixins/convertMinutesToHours'
    import truncate from 'components/shared/mixins/truncate'
    import ThumbnailInfoTable from 'components/shared/global-courses-items/thumbnails/ThumbnailInfoTable.vue'
    import ThumbnailMoreInfoHelper from 'components/shared/global-courses-items/helper/thumbnail-more-info-helper'
    import ThumbnailVerticalDetails from 'components/shared/global-courses-items/thumbnails/ThumbnailVerticalDetails'
    import ThumbnailInstructors from 'components/shared/global-courses-items/thumbnails/ThumbnailInstructors'

    export default {
        name: 'totem-learning-path-item-vertical',
        components: { LearningPathProgressBar, ThumbnailInfoTable, ThumbnailVerticalDetails, ThumbnailInstructors },
        mixins: [ LearningPathItemHelper, convertMinutesToHours, truncate, ThumbnailMoreInfoHelper ]
    }
</script>

<style lang="scss" scoped>
    @include totem_thumbnail_item_vertical;
</style>
